import { Component } from '@angular/core';

@Component({
  selector: 'promise-ai-preview',
  templateUrl: './promise-ai-preview.component.html',
  styleUrls: ['./promise-ai-preview.component.scss'],
  standalone: false,
})
export class PromiseAIPreviewComponent {}
